export const MESSAGE_TYPES = {
    CHAT: 'chat',
    DRAFT: 'draft',
};

export const FILE_SIZE = 21000000;
export const IPA_ACCEPTED = 'ACCEPTED';
export const INDICATIVE_TERMS = 'deal/save-indicative-terms';
